module.exports = __webpack_public_path__ + "static/media/ninx4.81ccb215.jpg";